import { gql } from "@apollo/client";
import WorkerFields from "../fragments/worker-fragment";

export default gql`
  mutation unverifyWorker($data: WorkerReasonInput!) {
    unverifyWorker(data: $data) {
      ...WorkerFields
    }
  }
  ${WorkerFields}
`;
